import { collection, addDoc, doc, setDoc, getDoc, getDocs, updateDoc, runTransaction, writeBatch, serverTimestamp, FieldValue } from "firebase/firestore";
import { db, auth } from '../utils/firebase.js';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { useAuthStore } from "../stores/useAuthStore.js";

export const _changeGroupName = async (groupId, groupName) => {
    if (!groupName || groupName.trim() === "") {
        return false;
    }

    try {
        console.log("groupId", groupId, groupName);
        const groupRef = doc(db, "groups", groupId);
        const taskDocRef = doc(collection(db, "groups", groupId, "tasks")); 

        let taskData = {
            'changeType': 'updateGroupName',
            'changeData': groupName,
            'status': 'pending',
            'requestedAt': serverTimestamp(),
            'requestedBy': auth.currentUser.uid,
            'timeToLive': new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
        }

        const batch = writeBatch(db);
        batch.set(taskDocRef, taskData);
        batch.update(groupRef, { groupName: groupName });
        await batch.commit();
    } catch (e) {
        console.log(e);
        return false;
    }

    return true;
}

export const _createGroup = async (groupName) => {
    try {
        const group = {
            groupName: groupName,
            gamesPlayed: {},
            groupAdmins: [auth.currentUser.uid],
            groupMembers: [auth.currentUser.uid],
            owner: auth.currentUser.uid,
            groupIcon: "meeple_orange"
        }

        var groupMember = {
            uid: auth.currentUser.uid,
            displayName: useAuthStore.getState().displayName || auth.currentUser.displayName
        }

        return await runTransaction(db, async (transaction) => {
            // Add group to groups collection
            const docRef = await addDoc(collection(db, "groups"), group);
            const userRef = doc(db, 'users', auth.currentUser.uid);
            var userData = { groups: [groupName] };
            var groupId = docRef.id;

            // Add groupMembers as a subcollection
            const groupMembersCollection = collection(db, "groups", groupId, "members");
            await addDoc(groupMembersCollection, groupMember);

            // Add group to user's groups
            const userDoc = await transaction.get(userRef);
            const userGroups = userDoc.data().groups || {};
            userGroups[groupId] = groupName;
            userData = { groups: userGroups };

            await transaction.update(userRef, userData);
            return groupId;
        });
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const _getGamesPlayed = async (groupId) => {
    const groupRef = doc(db, "groups", groupId);
    const groupDoc = await getDoc(groupRef);
    return groupDoc.data().gamesPlayed;
}

export const _getGameStats = async (groupId, game) => {
    const gameStatsRef = doc(db, "groups", groupId, "games", game);
    const gameStatsDoc = await getDoc(gameStatsRef);
    var gameStatsData = gameStatsDoc.data();

    if (!gameStatsData) {
        return {};
    }

    return gameStatsData;
}

export const _getGroup = async (groupId) => {
    const groupRef = doc(db, 'groups', groupId);
    const docSnap = await getDoc(groupRef);
    if (docSnap.exists()) {
        return docSnap.data();
    }
}

export const _rateGame = async (groupId, game, rating) => {
    const ratingRef = doc(db, "groups", groupId, "ratings", auth.currentUser.uid);
    await setDoc(ratingRef, { [game]: rating }, { merge: true });
}

export const _setGroupBackground = async (groupId, backgroundName) => {
    const groupRef = doc(db, "groups", groupId);
    await updateDoc(groupRef, { headerImage: backgroundName });
}

export const _setGroupIcon = async (groupId, iconName) => {
    const groupRef = doc(db, "groups", groupId);
    await updateDoc(groupRef, { icon: iconName });
    const storage = getStorage();
    var storageRef = ref(storage, `group_icons/light/${iconName}.png`);
    var url = await getDownloadURL(storageRef);
}

export const _toggleInactiveUser = async (groupId, memberId, isInactive) => {
    const memberRef = doc(db, "groups", groupId, "members", memberId);
    await updateDoc(memberRef, { inactive: isInactive });
}

